export interface CalendarViewParams {
  detailedTechCenter: boolean;
  detailedInterventionVehicle: boolean;
  detailedRV: boolean;
  monoCenter: boolean;
}
